import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";
import type { AcuityResolutionPayload, AcuityResolutionResponse, UUID } from "@/core/types";

export type AcuityResolutionVariables = {
  data: AcuityResolutionPayload;
  patientId: UUID;
};

export async function postAcuityResolution({
  data,
  patientId,
}: AcuityResolutionVariables): Promise<AcuityResolutionResponse> {
  return acuityRequestsTyped.post_acuity_resolution({
    context: { showLoader: false },
    data,
    patientId,
  });
}
